function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, layout, color, border, typography, variant } from 'styled-system';
import buttonBaseStyles from './ButtonStyle';
var variants = variant({
  variants: {
    small: {
      p: '2px 10px',
      fontSize: 1,
      borderRadius: '20px',
      height: '32px'
    },
    "default": {
      fontSize: 2
    }
  }
});
var ButtonBase = styled.button.attrs(function (_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick;
  return {
    onClick: disabled ? undefined : onClick
  };
})(_templateObject(), buttonBaseStyles, space, layout, color, border, typography, variants);
ButtonBase.propTypes = {
  as: PropTypes.oneOfType([PropTypes.oneOf(['button', 'a', 'summary', 'input']), PropTypes.elementType]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
export default ButtonBase;